import http from "@/utils/request"

export default {
	category: {
		list: async function (data = {}) {
			return await http.get("kb/category/list", data);
		},
		option: async function (data = {}) {
			return await http.get("kb/category/option", data);
		},
		add: async function (data = {}) {
			return await http.post("kb/category/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("kb/category/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("kb/category/del", data);
		},
	},
	article: {
		list: async function (data = {}) {
			return await http.get("kb/article/list", data);
		},
		info: async function (data = {}) {
			return await http.get("kb/article/info", data);
		},
		extract: async function (data = {}) {
			return await http.post("kb/article/extract", data, { timeout: 60000 });
		},
		add: async function (data = {}) {
			return await http.post("kb/article/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("kb/article/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("kb/article/del", data);
		},
		publish: async function (data = {}) {
			return await http.post("kb/article/publish", data, { timeout: 60000 });
		},
		offline: async function (data = {}) {
			return await http.post("kb/article/offline", data);
		},
		chunks: async function (data = {}) {
			return await http.get("kb/chunk/list", data);
		},
	},
}
